import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column align-center" },
    [
      _c("img", {
        staticClass: "mb-4 rounded-circle",
        style: { width: "80px", height: "80px", objectFit: "cover" },
        attrs: { src: _vm.doctorReview.avatar_small.url, alt: "/" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center mb-4" }, [
        _c("div", { staticClass: "text-subtitle-1" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.doctorReview.surname) +
              " " +
              _vm._s(_vm.doctorReview.firstname) +
              " " +
              _vm._s(_vm.doctorReview.secondname) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-2 mb-4 text-secondary--text" }, [
          _vm._v("\n      " + _vm._s(_vm.doctorReview.position) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-1 px-2" }, [
          _vm._v("\n      " + _vm._s(_setup.doctorReviewText) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        VBtn,
        {
          staticClass: "primary--text",
          attrs: { text: "" },
          on: { click: _setup.toggleShowMore },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.isShowMore
                  ? _setup.t("Скрыть", _setup.options)
                  : _setup.t("Показать всё", _setup.options)
              ) +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }